module.exports = __webpack_public_path__ + "img/qrcode.cf71eead.jpg";